import createReducer from './createReducer';
import {
  SET_ACTIVE_SPOT,
  CLEAR_ACTIVE_SPOT,
  SCROLL_TO_SPOT,
  SET_SCROLL_POSITION,
} from '../actions/animations';

const initialState = {
  activeSpotId: null,
  spotListScrollAnchor: null,
  scrollPositions: {
    spotList: {
      top: 0,
      left: 0,
    },
    camList: {
      top: 0,
      left: 0,
    },
  },
};

const handlers = {};

handlers[SET_ACTIVE_SPOT] = (state, { spotId }) => ({
  ...state,
  activeSpotId: spotId,
});

handlers[CLEAR_ACTIVE_SPOT] = state => ({
  ...state,
  activeSpotId: null,
});

handlers[SCROLL_TO_SPOT] = (state, { spotId }) => ({
  ...state,
  spotListScrollAnchor: spotId,
  activeSpotId: spotId,
});

handlers[SET_SCROLL_POSITION] = (state, { component, scrollPosition }) => ({
  ...state,
  scrollPositions: {
    ...state.scrollPositions,
    [component]: scrollPosition,
  },
});

export default createReducer(handlers, initialState);



// WEBPACK FOOTER //
// ./src/reducers/animations.js